<div class="container-fluid p-0">
  <div class="row m-0">
    <div class="col-12 p-0">
      <div class="login-card login-dark">
        <div>
          <div class="login-main">
            <form class="theme-form" [formGroup]="loginForm" (ngSubmit)="login()">
 
              <div class="text-center mb-4">
                <img src="assets/images/logo/final-logo.png" alt="Logo" class="login-logo">
              </div>
              <h4>Sign in to account</h4>
              <p class="mb-1">Enter your email & password to login</p>
 
              <div class="form-group">
                <label class="col-form-label">Email Address</label>
                <input class="form-control" type="email" placeholder="Enter your email" formControlName="email">
                @if(loginForm.controls['email'].touched && loginForm.controls['email'].errors?.['required']){
                <div class="text text-danger mt-1"> Email is required</div>
                }
                @if(loginForm.controls['email'].touched && loginForm.controls['email'].errors?.['email']){
                <div class="text text-danger mt-1">Invalid Email</div>
                }
              </div>
 
              <div class="form-group">
                <label class="col-form-label">Password</label>
                <div class="form-input position-relative">
                  <input class="form-control" [type]="show ? 'text' : 'password'"
                    formControlName="password"  placeholder="******" >
                  @if(!show){
                  <div class="show-hide" (click)="showPassword()"><span class="show"></span></div>
                  }@else{
                  <div class="show-hide" (click)="showPassword()"><span class="Hide"></span></div>
                  }
                  @if(loginForm.controls['password'].touched && loginForm.controls['password'].errors?.['required']){
                  <div class="text text-danger mt-1">Password is required </div>
                  }
                </div>
              </div>
 
              <div class="form-group mb-0">
                <!-- <div class="form-check">
                  <input class="checkbox-primary form-check-input" id="checkbox1" type="checkbox">
                  <label class="text-muted form-check-label" for="checkbox1">Remember password</label>
                </div> -->
                <!-- <a class="link">Forgot password?</a> -->
                <div class="text-end">
                  <button class="btn btn-primary d-block w-100 hover-animates mt-2" [disabled]="!loginForm.valid" (click)="login()"
                    type="button"><span>Sign in</span></button>
                </div>
              </div>
              <!-- <p class="text-center mt-4 mb-0">
                    By clicking Sign In, you agree to our
                    <span class="text-center mb-0 cursor-pointer underline" style="color: #121280;" (click)="showPrivacyPolicy()">
                      Terms and Privacy Policy
                    </span>.
                  </p> -->

                  <p class="mt-2 mb-0" style="font-size: 12px;">
                By clicking Sign In, you agree to our
                <span class="cursor-pointer back-link mb-0"  style="font-size: 12px; color: #121280;" (click)="showPrivacyPolicy()">
                  Terms and Privacy Policy
                </span>.
              </p>
 
              <p class="text-center mt-4 mb-0" style="color: #94278E;">Powered By Simpli-Fi Automation</p>
                  <p class=" text-center mt-1 mb-0" style="color: #94278E;">Version 1.0.0</p>
 
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>